/**
 * Video Testimonials — JavaScript
 * Handles: Lightbox modal for Option C
 */
(function () {
  'use strict';

  function initLightbox() {
    var modal = document.getElementById('vt-lightbox-modal');
    if (!modal) return;

    var overlay = modal.querySelector('.vt-modal__overlay');
    var closeBtn = modal.querySelector('.vt-modal__close');
    var videoContainer = modal.querySelector('.vt-modal__video');
    var nameEl = modal.querySelector('.vt-modal__info .vt-info__name');
    var roleEl = modal.querySelector('.vt-modal__info .vt-info__role');
    var descEl = modal.querySelector('.vt-modal__info .vt-info__desc');
    var ctaEl = modal.querySelector('.vt-modal__info .vt-info__cta');

    function getYouTubeId(url) {
      if (!url) return null;
      var match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([a-zA-Z0-9_-]{11})/);
      return match ? match[1] : null;
    }

    function escapeAttr(str) {
      return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function openModal(trigger) {
      var videoUrl = trigger.getAttribute('data-video-url');
      var hasVideo = trigger.getAttribute('data-has-video') === '1';
      var name = trigger.getAttribute('data-name') || '';
      var role = trigger.getAttribute('data-role') || '';
      var desc = trigger.getAttribute('data-desc') || '';
      var cta = trigger.getAttribute('data-cta-url') || '';
      var ctaText = trigger.getAttribute('data-cta-text') || 'Shop Now';

      var card = trigger.closest('.vt-grid__card');
      var template = card ? card.querySelector('template[data-vt-video-template]') : null;

      var ytId = getYouTubeId(videoUrl);
      if (hasVideo && template) {
        videoContainer.innerHTML = '';
        var clone = template.content.cloneNode(true);
        videoContainer.appendChild(clone);
        var videoEl = videoContainer.querySelector('video');
        if (videoEl) {
          videoEl.play().catch(function () {});
        }
      } else if (ytId) {
        videoContainer.innerHTML = '<iframe src="https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
      } else if (videoUrl) {
        videoContainer.innerHTML = '<iframe src="' + videoUrl + '" allow="autoplay" allowfullscreen></iframe>';
      }

      if (nameEl) nameEl.textContent = name;
      if (roleEl) roleEl.textContent = role;
      if (descEl) descEl.textContent = desc;
      if (ctaEl) {
        if (cta) {
          ctaEl.href = cta;
          ctaEl.textContent = ctaText;
          ctaEl.style.display = '';
        } else {
          ctaEl.style.display = 'none';
        }
      }

      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.setAttribute('hidden', '');
      videoContainer.innerHTML = '';
      document.body.style.overflow = '';
    }

    // Click on thumbnails
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-vt-lightbox]');
      if (trigger) {
        e.preventDefault();
        openModal(trigger);
      }
    });

    // Close handlers
    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target.closest('.vt-modal__video') || e.target.closest('.vt-modal__info')) {
        return;
      }
      closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) {
        closeModal();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLightbox);
  } else {
    initLightbox();
  }
})();